var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.appLoading && !_vm.user)?_c('preloader',{staticClass:"app__preloader"}):[(!_vm.isWithoutNav && _vm.user)?_c('navigation'):_vm._e(),_c('router-view',{staticStyle:{"flex":"1 0 auto"}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }